<template>
    <div class="credentials-details-with-async-fallback">
      <back-navigation-header :on-back="handleBack" :disabled="isLoading" :show-back="!goToAsyncFallback"/>
      <async-fallback v-if="goToAsyncFallback" :source="source"/>
      <slot v-else name="credentials"/>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment';
import AsyncFallback from './AsyncFallback.vue';
import ModalBus from '../../event-bus/modal-bus';
import BackNavigationHeader from '../app-header/BackNavigationHeader.vue';
import LoadingPopupWithAsyncFallback from './LoadingPopupWithAsyncFallback.vue';
import Segment from '../../Segment';

export default {
  name: 'CredentialsDetailsWithAsyncFallback',
  components: {
    AsyncFallback,
    BackNavigationHeader,
  },
  props: {
    handleBack: {
      type: Function,
      required: true,
    },
    source: {
      type: Object,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    loadingStartTime: {
      type: String,
    },
  },
  data() {
    return {
      asyncTimeoutReached: false,
      timeout: null,
    };
  },
  async created() {
    Segment.trackUserGot('CreateCredentialsEntered', { sourceType: this.source.type, sourceName: this.source.sourceName });
    if (this.isLoading) {
      const loadingTimeInSecs = moment().diff(moment(this.loadingStartTime), 'seconds');
      if (loadingTimeInSecs > 60) {
        this.asyncTimeoutReached = true;
        await this.fetchOnboardingState();
      } else {
        this.setTimeout(this.loadingStartTime);
        this.openLoadingPopup(this.loadingStartTime);
      }
    }
  },
  beforeDestroy() {
    this.closeModal();
  },
  computed: {
    goToAsyncFallback() {
      return this.asyncTimeoutReached && this.isLoading;
    },
    sourceTypeString() {
      return this.source.type === 'bank' ? 'הבנק' : 'חברת האשראי';
    },
    loadingTitle() {
      if (!this.loadingIsLong) {
        return 'עוד רגע ממשיכים...';
      }
      if (this.loadingIsLong) {
        return `החיבור לאתר ${this.sourceTypeString} לוקח קצת יותר זמן מהרגיל`;
      }
      return '';
    },
    loadingSubtitle() {
      if (!this.loadingIsLong) {
        return `המערכת מתחברת לאתר ${this.sourceTypeString}.`;
      }
      if (this.loadingIsLong) {
        return 'המערכת ממשיכה לנסות...';
      }
      return '';
    },
  },
  methods: {
    ...mapActions('onboardingState', ['fetchOnboardingState']),
    setTimeout(loadingStartTime) {
      const loadingTimeInSecs = moment().diff(moment(loadingStartTime), 'seconds');
      this.clearAsyncTimeout();
      this.timeout = setTimeout(async () => {
        await this.fetchOnboardingState();
        this.asyncTimeoutReached = true;
      }, (60 - loadingTimeInSecs) * 1000);
    },
    openLoadingPopup(loadingStartTime) {
      ModalBus.$emit('open', {
        component: LoadingPopupWithAsyncFallback,
        popupAlignment: 'center',
        props: {
          source: this.source,
          loadingStartTime,
        },
      });
    },
    closeModal() {
      ModalBus.$emit('close-modal');
    },

    clearAsyncTimeout() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
    },
  },
  watch: {
    isLoading(newValue, oldValue) {
      if (newValue) {
        const loadingStartTime = moment().toString();
        this.setTimeout(loadingStartTime);
        this.openLoadingPopup(loadingStartTime);
      }
      if (oldValue && !newValue) {
        this.asyncTimeoutReached = false;
        this.clearAsyncTimeout();
        this.closeModal();
      }
    },
    goToAsyncFallback(newValue, oldValue) {
      if (newValue) {
        this.closeModal();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
